import React, { useState, useEffect, ReactNode, useMemo } from 'react';

import { branding } from '../../config/enum';
import { useBranding, applyThemeToDocument } from '../BrandingContext';

import ThemeContext, { initialThemeState } from './ThemeContext';

interface ThemeProviderProperties {
  children: ReactNode;
}

/**
 * Theme Provider function component
 * @param {any} param0 - The param0
 * @param {any} param0.children - The children prop
 */
export function ThemeProvider({ children }: ThemeProviderProperties) {
  const currentBranding: string = process.env.REACT_APP_BRANDING || branding.ENERGIC;
  const [theme, setTheme] = useState<string>(initialThemeState.theme);
  const { brandData } = useBranding();

  const localStorage = window?.localStorage;

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('globalTheme', theme);
    if (brandData?.theme) {
      applyThemeToDocument(brandData.theme, theme);
    }
  }, [theme, brandData]);

  useEffect(() => {
    document.documentElement.setAttribute('data-branding', currentBranding);
  }, []);

  // Use useMemo to memoize the context value
  const value = useMemo(() => ({ theme, setTheme }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      <div className={`theme--${theme}`}>{children}</div>
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
